import { FC } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import Path from "src/constants/path";
import { createAppPath, preserveQueryParams } from "src/lib/createAppPath";

/**
 * Redirect component that maps old program routes to new journey routes
 * while preserving both path parameters and query parameters.
 *
 * Old route: /app/program/:program/:module?/:task?
 * New route: /app/journey/:module?/:task?
 *
 * The :program param is dropped since journey is now the unified route.
 */
const ProgramToJourneyRedirect: FC = () => {
  const location = useLocation();
  const params = useParams();

  // Build the new journey path with preserved module/task params
  const basePath: string = createAppPath(Path.journey);
  const pathSegments = [basePath];

  if (params.module) {
    pathSegments.push(params.module);
    if (params.task) {
      pathSegments.push(params.task);
    }
  }

  const targetPath = pathSegments.join("/");

  // Preserve query parameters
  const redirectPath = preserveQueryParams(targetPath, location.search);

  return <Navigate to={redirectPath} replace />;
};

export default ProgramToJourneyRedirect;
